import dynamic from 'next/dynamic';
import PageFooter from '@/common/PageFooter';
import PageHeader from '@/common/PageHeader';
import { isTest } from '~/constants/environment';
import BatterySize from './BatterySize';
import Disclaimer from './Disclaimer';
import EvBasics from './EvBasics';
import EvCharging from './EvCharging';
import EvChecklist from './EvChecklist';
import EvHero from './EvHero';
import EvInspectionBanner from './EvInspectionBanner';
import FindingEv from './FindingEv';
import EvCarousel from '../common/EvCarousel/EvCarousel';
import { Divider, Main } from '../styles';
import { generateEvElectricLink } from '../utils/generateSrpLink';

const FeatureBranch = dynamic(
  () =>
    import(/* webpackChunkName: "FeatureBranch" */ '@/common/FeatureBranch'),
  { ssr: false }
);

const carouselFiltersToSet = {
  fuelTypes: ['Electric']
};

export default function GuideToBuyingEvContainer() {
  return (
    <>
      {isTest && <FeatureBranch className="max-w-[1440px]" />}
      <div className="mx-auto max-w-[1440px]">
        <PageHeader />
        <Main>
          <EvHero />
          <Divider className="md:hidden" />
          <BatterySize />
          <EvBasics />
          <EvCharging />
          <FindingEv />
          <EvInspectionBanner />
          <EvChecklist />
          <Divider />
          <EvCarousel
            className="!py-6xl sm:!pb-3xl md:!pb-4xl md:!pt-8xl"
            title="Start your search today"
            subtitle="Discover great deals on EVs and plug-in hybrids"
            filterToSet={carouselFiltersToSet}
            ctaUrl={generateEvElectricLink()}
          />
          <Disclaimer />
        </Main>
        <PageFooter className="bg-canvas-default" />
      </div>
    </>
  );
}
